import { p as path$1 } from './path.js';
import { g as global$1 } from './global.js';
import { i as isCallable$1 } from './is-callable.js';

var path = path$1;
var global = global$1;
var isCallable = isCallable$1;

var aFunction = function (variable) {
  return isCallable(variable) ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};

export { getBuiltIn as g };
//# sourceMappingURL=get-built-in.js.map
